// extracted by mini-css-extract-plugin
module.exports = {"root":"LegendsForApplicationMonitoring_root__18VO_"};